import { RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './app-layout/app-layout.component';
import { AccountLayoutComponent } from './account-layout/account-layout.component';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
  {
    path: '', component: AppLayoutComponent, children:
      [
        {
          path: 'dashboard',
          loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule),
          data: {
            breadcrumb: {
              label: 'Dashboard',
              info: 'home'
            }
          }
        },
      ]
  },

  {
    path: '', component: AccountLayoutComponent, children:
      [
        {path: 'account', loadChildren: () => import('../account/account.module').then(m => m.AccountModule)}
      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule {
}
